import { apiClient } from "./ApiConfig";

export const AdApi = {
  createAd: (body: any) => {
    return apiClient.post("/product-ad/v2/create", body);
  },
  getType: () => {
    return apiClient.get("/product-ad/ad-types");
  },
  updateAd: (body: any) => {
    return apiClient.post("/product-ad/v2/update", body);
  },
  repostAd: (body: any) => {
    return apiClient.post("/product-ad/repost", body);
  },
  changeStatus: (body: any) => {
    return apiClient.post("/product-ad/change-status", body);
  },
  getAdDetail: (adID: number) => {
    return apiClient.get(`/product-ad/detail?product_ad_id=${adID}`);
  },
  getAll: () => {
    return apiClient.get("/product-ad/all");
  },
};
